import { Routes } from '@angular/router';
import { isDescriptiveBoatPath } from './core/utils/boat-url.util';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PublicLayoutComponent } from './layout/public-layout/public-layout.component';
import { HomeComponent } from './public/home/home.component';
import { ProductDetailResolver } from './core/resolvers/product-detail.resolver';

export const routes: Routes = [
  {
    path: 'admin',
    // Staff editors use browser-only libraries and are never server rendered.
    loadChildren: () => isPlatformBrowser(inject(PLATFORM_ID))
      ? import('./admin/admin.routes').then((m) => m.ADMIN_ROUTES)
      : [],
  },
  {
    path: 'maintenance-preview',
    loadComponent: () =>
      import('./shared/components/maintenance/maintenance.component').then(
        (m) => m.MaintenanceComponent,
      ),
  },
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      { path: '', component: HomeComponent },
      {
        path: 'about',
        loadComponent: () => import('./public/about/about.component').then((m) => m.AboutComponent),
      },
      {
        path: 'contact',
        loadComponent: () =>
          import('./public/contact/contact.component').then((m) => m.ContactComponent),
      },
      {
        path: 'privacy-policy',
        loadComponent: () =>
          import('./public/privacy-policy/privacy-policy').then((m) => m.PrivacyPolicy),
      },
      {
        path: 'terms-of-service',
        loadComponent: () =>
          import('./public/terms-of-service/terms-of-service').then((m) => m.TermsOfService),
      },
      {
        path: 'yachts',
        loadComponent: () =>
          import('./public/yachts/yachts.component').then((m) => m.YachtsComponent),
      },
      {
        path: 'boats/:id/:yachtType/:slug/:reference',
        canMatch: [(_route, segments) =>
          isDescriptiveBoatPath('/' + segments.map(segment => segment.path).join('/'))],
        loadComponent: () =>
          import('./public/boat-detail/boat-detail.component').then((m) => m.BoatDetailComponent),
        resolve: { product: ProductDetailResolver },
      },
      {
        path: 'boats/:id',
        loadComponent: () =>
          import('./public/boat-detail/boat-detail.component').then((m) => m.BoatDetailComponent),
        resolve: { product: ProductDetailResolver },
      },
      {
        path: 'merchandises',
        loadComponent: () =>
          import('./public/search-merchandises/search-merchandises.component').then(
            (m) => m.SearchMerchandisesComponent,
          ),
      },
      {
        path: 'merchandise/:id',
        loadComponent: () =>
          import('./public/merchandise-detail/merchandise-detail.component').then(
            (m) => m.MerchandiseDetailComponent,
          ),
        resolve: { product: ProductDetailResolver },
      },
      {
        path: 'product/:id',
        loadComponent: () =>
          import('./public/product-redirect/product-redirect.component').then(
            (m) => m.ProductRedirectComponent,
          ),
      },
      { path: 'yachts/:id', redirectTo: 'boats/:id', pathMatch: 'full' },
      { path: 'boat/:id', redirectTo: 'boats/:id', pathMatch: 'full' },
      { path: 'merchandises/:id', redirectTo: 'merchandise/:id', pathMatch: 'full' },
      {
        path: '**',
        loadComponent: () =>
          import('./features/not-found/not-found').then((m) => m.NotFoundComponent),
      },
    ],
  },
];
